export default __webpack_public_path__ + "static/media/tituloEN.e8e8509a.png";